module.exports = __webpack_public_path__ + "static/media/singpassbtnNew.16b519a2.svg";